import React, { useState } from 'react';
import styled from 'styled-components';

const GuideLanding = () => {
  return (
    <Style>
      <div>사용설명서</div>
    </Style>
  );
};

export default GuideLanding;

export const Style = styled.div``;
